'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-table-responsive',
    cnTable = "".concat(CLASSNAME, "__table"),
    cnBody = "".concat(CLASSNAME, "__body"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCell = "".concat(CLASSNAME, "__cell"),
    cnCellTitle = "".concat(CLASSNAME, "__cell-title"),
    cnFixed = "".concat(CLASSNAME, "--fixed"),
    cnHeaderColumn = "".concat(CLASSNAME, "--header-column");
/**
 * 
 */

function TableResponsive(_ref) {
  var _classNames;

  var classNameCell = _ref.classNameCell,
      classNameRow = _ref.classNameRow,
      className = _ref.className,
      colWidth = _ref.colWidth,
      fixed = _ref.fixed,
      headerColumn = _ref.headerColumn,
      headline = _ref.headline,
      items = _ref.items;

  var myFilter = function myFilter(a) {
    return !(typeof a === 'undefined' || a === null);
  };

  var rows = _rollupPluginBabelHelpers.toConsumableArray(items).filter(myFilter);

  var _rows = _rollupPluginBabelHelpers.slicedToArray(rows, 1),
      header = _rows[0];

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, CLASSNAME, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnFixed, fixed), _rollupPluginBabelHelpers.defineProperty(_classNames, cnHeaderColumn, headerColumn), _classNames))
  }, headline && /*#__PURE__*/React__default.createElement("h2", null, headline), /*#__PURE__*/React__default.createElement("div", {
    className: cnTable
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnBody
  }, rows.map(function (item, i) {
    var _item$content = item.content,
        content = _item$content === void 0 ? item : _item$content,
        options = item.options;
    return /*#__PURE__*/React__default.createElement("div", _rollupPluginBabelHelpers.extends({
      className: classNames(cnRow, classNameRow),
      key: i
    }, options), content.filter(myFilter).map(function (cell, j) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnCell, classNameCell),
        key: j,
        style: (colWidth === null || colWidth === void 0 ? void 0 : colWidth[j]) ? {
          width: colWidth === null || colWidth === void 0 ? void 0 : colWidth[j]
        } : undefined
      }, !j || !headerColumn ? null : /*#__PURE__*/React__default.createElement("span", {
        className: cnCellTitle
      }, header[j]), cell);
    }));
  }))));
}
TableResponsive.propTypes = {
  /** Additional class name for each cell */
  classNameCell: PropTypes.string,

  /** Additional class name for each row */
  classNameRow: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** Array of widths */
  colWidth: PropTypes.array,

  /** True for fixed styling */
  fixed: PropTypes.bool,

  /** True if first column is a header */
  headerColumn: PropTypes.bool,

  /** Title */
  headline: PropTypes.string,

  /** Array of table items */
  items: PropTypes.array.isRequired,

  /** True for mobiel styling */
  mobile: PropTypes.bool
};
TableResponsive.defaultProps = {
  items: [['N/A', 'N/A'], ['N/A', 'N/A']]
};

module.exports = TableResponsive;
